import type { ReactNode } from 'react';

export const symbol_sports_football: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M482-482ZM371-185 184-372q-8 42-6 96.5t10 83.5q29 8 85 11.5t98-4.5Zm74-11q62-12 116.5-40t94.5-68q39-39 66.5-91.5T764-515L515-764q-63 14-117.5 41.5T304-656q-39 39-65.5 93.5T196-445l249 249Zm331-392q8-42 6-96.5T772-768q-29-8-85-11.5t-98 4.5l187 187ZM296-120q-54 0-96.5-7.5T146-146q-11-11-18.5-53.5T120-296q0-125 36-232.5T258-702q66-66 173.5-102T664-840q54 0 96.5 7.5T814-814q11 11 18.5 53.5T840-664q0 125-36 232.5T702-258q-66 66-173.5 102T296-120Zm51-269 224-224q9-9 21-9t21 9q9 9 9 21t-9 21L389-347q-9 9-21 9t-21-9q-9-9-9-21t9-21Z"
		/>
	</svg>
);
